var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDelete = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.393,
    height: 18,
    viewBox: "0 0 15.393 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39849",
    "data-name": "Group 39849",
    transform: "translate(-142.724 -141.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63904",
    "data-name": "Path 63904",
    d: "M158.117,146.2a2.541,2.541,0,0,0-2.511-2.511h-2.359l-.02-.1a2.847,2.847,0,0,0-1.01-1.67,2.86,2.86,0,0,0-4.6,1.671l-.021.1h-2.359a2.542,2.542,0,0,0-1.028,4.852l.074.034v7.819a2.9,2.9,0,0,0,2.89,2.889h6.509a2.9,2.9,0,0,0,2.886-2.889v-7.821l.073-.034A2.558,2.558,0,0,0,158.117,146.2Zm-8.808-2.7a1.289,1.289,0,0,1,2.226,0l.113.191H149.2Zm4.369,14.212h-6.509a1.325,1.325,0,0,1-1.32-1.314v-7.633h9.144l0,7.63A1.324,1.324,0,0,1,153.678,157.709Zm2.863-11.4a.949.949,0,0,1-.935.883h-10.37a.95.95,0,0,1-.938-.937V146.2a.947.947,0,0,1,.937-.937h10.372a.953.953,0,0,1,.941.97Z",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63905",
    "data-name": "Path 63905",
    d: "M148.817,150.181a.786.786,0,0,0-.786.786V155.5a.785.785,0,0,0,1.571,0v-4.531A.786.786,0,0,0,148.817,150.181Z",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63906",
    "data-name": "Path 63906",
    d: "M152.022,150.183a.787.787,0,0,0-.786.786v4.53a.786.786,0,0,0,1.572,0v-4.53A.787.787,0,0,0,152.022,150.183Z",
    fill: "#95A1B2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.4e63d8c5.svg";
export { ForwardRef as ReactComponent };